import http from '../../baseUrl/HttpCommon';
import authHeader from '../authHeader/AuthHeader';

const getContribution = (data) => {
  return http.get(
    `/DashBoard/load_dashboard?CompanyId=${data.companyId}&ResultArea=${data.ResultArea}&FromMonth=${data.FromMonth}&ToMonth=${data.ToMonth}&Year=${data.Year}&endYear=${data.endYear}`,
    {
      headers: authHeader(),
    },
  );
};

const getContributionSingle = (data) => {
  debugger;
  return http.get(`/DashBoard/load_dashboard?CompanyId=${data}`, {
    headers: authHeader(),
  });
};

const previewAllData = ({ monthName, year, companyId, c3HeaderId }) => {
  return http.get('/C3/C3Report', {
    params: { monthName, year, companyId, c3HeaderId },
    headers: authHeader(),
  });
};

const getCompanyDropdown = (data) => {
  console.log('getCompanyDropdown', data);
  return http.get(
    `/DashBoard/FillCompanyDropdown?ParentId=${data.ParentId}&UserID=${data.UserID}&roleId=${data.roleId}`,
    {
      headers: authHeader(),
    },
  );
};

const previewNWData = ({ monthId, year, companyId, c3HeaderId }) => {
  return http.get('/NonDirector/checkDirectorReports', {
    params: { monthId, year, companyId, c3HeaderId },
    headers: authHeader(),
  });
};

const ImportCThree = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return http.get(`/C3/btn_DownloadSubmittedC3_Click?${queryString}`, {
    headers: authHeader(),
  });
};

const ImportCThreeLatest = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return http.get(`/C3/btn_ImportLastC3_Click?${queryString}`, null, {
    headers: authHeader(),
  });
};

const dashboardSubmitDirector = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return http.post(`/C3/SubmitC3Bulk?${queryString}`, null, {
    headers: authHeader(),
  });
};

const dashboardSubmitContribution = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return http.post(`/NonDirector/NWSubmitC3Bulk?${queryString}`, null, {
    headers: authHeader(),
  });
};

const paynowdata = (formData) => {
  return http.post(`/Payment/BuySubscription`, formData, {
    headers: authHeader(),
  });
};

const payNowDataCyber = (formData) => {
  return http.post(`/Payment/payNowDataCyberSource`, formData, {
    headers: authHeader(),
  });
};

const payNowCyberSourceTestAndLive = (formData) => {
  return http.post(`/Payment/payNowCyberSourceTestAndLive`, formData, {
    headers: authHeader(),
  });
};
const saveConfig = (formData) => {
  return http.post(`/Payment/saveConfigCyberSource`, formData, {
    headers: authHeader(),
  });
};
const TestTransaction = () => {
  return http.get(`/Payment/TestPaymentTransactionHistory`, {
    headers: authHeader(),
  });
};

// const downloadTransaction = ({ userId, c3HeaderId, transactionID }) => {
//   debugger;

//   return http.get(
//     `/Payment/TransactionReport?userId=${userId}&c3HeaderId=${c3HeaderId}&transactionID=${transactionID}`,
//     {
//       headers: authHeader(),
//     },
//   );
// };

const downloadTransaction = ({ userId, c3HeaderId, transactionID = null }) => {
  // Build query parameters
  const params = new URLSearchParams();
  params.append('userId', userId);
  params.append('c3HeaderId', c3HeaderId);

  // Only add transactionID if it exists
  if (transactionID) {
    params.append('transactionID', transactionID);
  }

  return http.get(`/Payment/TransactionReport?${params.toString()}`, {
    headers: authHeader(),
  });
};

const CardDetailsCyber = (params) => {
  return http.get(`/Payment/CardDetailsByCyber?userId=${params}`, null, {
    headers: authHeader(),
  });
};

const paymentResponse = (formData) => {
  return http.post(`/Payment/Paymentsuccess`, formData, {
    headers: authHeader(),
  });
};

const paymentResponseCancel = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return http.post(`/Payment/PaymentCancel?${queryString}`, {
    headers: authHeader(),
  });
};

const getLoaddashboardPaymentStatus = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return http.post(`/Payment/AdminTranactionHistory?${queryString}`, null, {
    headers: authHeader(),
  });
};

// const getLoaddashboardPaymentStatus = (params) => {
//   const queryString = new URLSearchParams(params).toString();
//   return http.post(`/Payment/AdminTranactionHistoryData?${queryString}`, null, {
//     headers: authHeader(),
//   });
// };

const getAllRoles = () => {
  return http.get(`/Administration/GetAllRoles`, {
    headers: authHeader(),
  });
};

const postSaveRole = (data) => {
  return http.post(`/Administration/SaveRole`, data, {
    headers: authHeader(),
  });
};

const getRoleById = (Roleid) => {
  console.log('getRoleById', Roleid);
  return http.get(`/Administration/GetRoleById?Roleid=${Roleid}`, {
    headers: authHeader(),
  });
};

const deleteRole = (roleId) => {
  return http.get(`/Administration/DeleteRole/${roleId}`, {
    headers: authHeader(),
  });
};

const updateRole = (data) => {
  return http.post(`/Administration/UpdateRole`, data, {
    headers: authHeader(),
  });
};

const uploadExcelData = (formData) => {
  return http.post(`/Payment/UploadCyberCsv`, formData, {
    headers: {
      ...authHeader(),
      'Content-Type': 'multipart/form-data',
    },
  });
};

const reconciliationGet = (pageNumber, pageSize) => {
  debugger;
  return http.get(
    `/Payment/GetReconciliationDataCyber?pageNumber=${pageNumber}&pageSize=${pageSize}`,
    {
      headers: authHeader(),
    },
  );
};

const ExcelreconciliationGet = () => {
  debugger;
  return http.get(`/Payment/GetReconciliationDataCyberData`, {
    headers: authHeader(),
  });
};

const ExportCompany = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return http.post(`/SelfEmployee/Export_C3_Data?${queryString}`, null, {
    headers: authHeader(),
  });
};

const ExportNotWorking = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return http.post(`/SelfEmployee/Export_button_Data?${queryString}`, null, {
    headers: authHeader(),
  });
};

const submitPayment = (params) => {
  return http.post('/Payment/OfflinepayNowDataCyberSource', params, {
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json',
    },
  });
};

const getReportedList = ({ HeaderId }) => {
  return http.get(`/Payment/GetOfflinePaymentData?HeaderId=${HeaderId}`);
};

const getReportedListNW = ({ HeaderId }) => {
  return http.get(`/Payment/GetOfflinePaymentDataDirector?HeaderId=${HeaderId}`);
};

const getReportedListSelf = ({ HeaderId }) => {
  return http.get(`/Payment/GetOfflinePaymentDataSelfEmp?SelfHeaderId=${HeaderId}`);
};

const ReconcileData = (payload) => {
  debugger;
  return http.post('/Payment/UpdateReconciliationData', payload, {
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json',
    },
  });
};

const reconcilationUpdate = (payload) => {
  debugger;
  return http.post('/Payment/UpdateReconciliationNotes', payload, {
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json',
    },
  });
};



const getReconcilationUpdate = ({ HeaderId }) => {
  return http.get(`/Payment/GetOfflinePaymentDataSelfEmp?SelfHeaderId=${HeaderId}`);
};

const CustomizeData = (payload) => {
  debugger;
  return http.post('/Payment/PostCyberSourceList', payload, {
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json',
    },
  });
};

const ColumnGet = (UserId) => {
  return http.get(`/Payment/GetCyberSourceFields?UserId=${UserId}`, {
    headers: authHeader(),
  });
};

const DashboardService = {
  getContribution,
  getContributionSingle,
  previewAllData,
  getCompanyDropdown,
  previewNWData,
  ImportCThree,
  ImportCThreeLatest,
  dashboardSubmitDirector,
  dashboardSubmitContribution,
  paynowdata,
  payNowDataCyber,
  payNowCyberSourceTestAndLive,
  downloadTransaction,
  TestTransaction,
  saveConfig,
  paymentResponse,
  paymentResponseCancel,
  getLoaddashboardPaymentStatus,
  getAllRoles,
  postSaveRole,
  getRoleById,
  deleteRole,
  updateRole,
  uploadExcelData,
  reconciliationGet,
  CardDetailsCyber,
  ExportCompany,
  ExportNotWorking,
  submitPayment,
  getReportedList,
  getReportedListNW,
  getReportedListSelf,
  ReconcileData,
  ColumnGet,
  CustomizeData,
  ExcelreconciliationGet,
  reconcilationUpdate,
  getReconcilationUpdate,
};

export default DashboardService;
